<template>
  <div id="app">
    <loading-bar v-if="app.loadingCount > 0"/>
    <navigation />
    <router-view class="container mb-3"></router-view>
  </div>
</template>

<script>
import LoadingBar from './components/LoadingBar.vue'
import Navigation from '@/components/navigation/Navigation.vue'

export default {
  name: 'app',
  data () {
    return {
      app: this.$store.state.app
    }
  },
  components: {
    LoadingBar,
    Navigation
  },
  computed: {},
  methods: {
    handleRedirect() {
      if (this.app.account.id === null && this.$route.name !== 'login') {
        this.$router.push({ name: 'login' });
      }
      if (this.app.account.id !== null && this.$route.name === undefined) {
        this.$router.push({ name: 'bookmarks' });
      }
    },
  },
  created() {
    this.$store.dispatch('fetchCategories');
    this.$store.dispatch('checkSession');
  },
  watch: {
    'app.checkingSession': {
      handler(checkingSession) {
        if (checkingSession === false) {
          this.handleRedirect();
        }
      }
    }
  }
}
</script>

<style lang="scss">
* { margin: 0; padding: 0; }

.container { max-width: 1500px; }

$dark-blue: #004a99;
$dark-blue-lighter: lighten($dark-blue, 10%);

nav.navbar { background-color: $dark-blue; }
.btn-primary {
  background-color: $dark-blue;
  border-color: $dark-blue;

  &:hover, &:focus {
    background-color: $dark-blue-lighter;
    border-color: $dark-blue-lighter;
  }
}

.table {
  font-size: 14px;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .container { margin-top: 10px }
}

ul { list-style-type: none; }

table th {
  background: #004a99 !important;
  border-color: lighten(#004a99, 5%) !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue